
<div class="basic_product_details_cont for_preorder_container">
	<div class="price_and_product_cont">
		<!-- <p class="price" *ngIf="!discounterPrice">

			{{storeForex.selectedCurrencyName | uppercase}}
			{{price |  currencyConverter | number: '1.0-2'}} / {{productData.unit }} <br />
		</p>

		<p class="new price" *ngIf="discounterPrice">
			{{storeForex.selectedCurrencyName | uppercase}}
			<span class="previous_price">
				{{price |  currencyConverter | number: '1.0-2'}}
			</span> {{discounterPrice |  currencyConverter | number: '1.0-2'}} / {{productData.unit }} <br />
		</p> -->

		<p class="price">
			{{selectedCurrency | uppercase}}


			<span class="price_span {{storediscountedPrice?'previous_price':''}}">{{undiscountedPrice |  currencyConverter | number: '1.0-2'}}</span>

			<ng-container *ngIf="storediscountedPrice">
				{{(storediscountedPrice) |  currencyConverter | number: '1.0-2'}}
			</ng-container>
			/   {{productData.unit }}
			<br />
			<span>Incl. Taxes</span>
		</p>

	</div>
</div>
